// extracted by mini-css-extract-plugin
export default {"form":"form_form__ZoW03","form__input":"form_form__input__F-OJR","form__btn":"form_form__btn__BpVD1"};